<template>
    <div>
        <app-header>
            <template slot="title">Meine Deals</template>
        </app-header>
        <div class="container">
            <div class="table-wrapper-scroll-y">
                <app-list-deals></app-list-deals>
            </div>
        </div>
        <div id="nav">
            <app-nav></app-nav>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'
  import ListDeals from '../components/deals/ListDeals'

  export default {
    components: {
      appHeader: Header,
      appNav: Nav,
      appListDeals: ListDeals
    }
  }
</script>
<style lang="scss" scoped>
    .table-wrapper-scroll-y {
        max-height: 550px;
    }

    .container {
        padding: 0 20px;
    }

</style>
